<template>
  <div class="content-tab">
    <div class="content-body debug">
      <!-- {{sysLog}} -->
      <div class="debug-toggle">
      QOS Debug Mode:<toggle :on="isQosEnable" @click.native="onSwitchBtn('qos')"></toggle>
      LLDP Debug Mode:<toggle :on="isLldpEnable" @click.native="onSwitchBtn('lldp')"></toggle>
      </div>
      <button class="q-button blue-btn-full footer-btn" @click="onClick()" :title="'System Log download'">System Log download</button>
    <div class="footer"></div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import toggle from './module/Toggle'
export default {
  name: 'debug',
  components: {
    toggle
  },
  data () {
    return {
      isQosEnable: false,
      isLldpEnable: false
    }
  },
  mounted () {
  },
  created: async function () {
    let menu = {
      title: 'Debug Mode'
    }
    this.getData()
    this.$store.commit('updateMenu', menu)
  },
  methods: {
    async getData () {
      let me = this
      this.$store.commit('updateFullLoadingStatus', true)
      await this.getQosDebug().then((res) => {
        me.isQosEnable = false
        if (res.data.result['Flag'] === 251) me.isQosEnable = true
      })
      await this.getLldpDebug().then((res) => {
        me.isLldpEnable = false
        if (res.data.result['Level'] === 'all') me.isLldpEnable = true
      })
      this.$store.commit('updateFullLoadingStatus', false)
    },
    onClick () {
      this.$store.commit('updateFullLoadingStatus', true)
      this.getSysLog().then((res) => {
        var elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(res.data)
        elem.download = 'system_log.conf'
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
        window.URL.revokeObjectURL(res.data)
        this.$store.commit('updateFullLoadingStatus', false)
      })
    },
    onSwitchBtn (type) {
      let me = this
      if (type === 'qos') {
        let status = 0
        if (this.isQosEnable) {
        } else {
          status = 251
        }
        me.setQosDebug(status).then(() => {
          me.getData()
        })
      } else if (type === 'lldp') {
        let status = null
        if (this.isLldpEnable) {
          status = 'disable all'
        } else {
          status = 'enable all'
        }
        me.setLldpDebug(status).then(() => {
          me.getData()
        })
      }
    },
    ...mapActions(['getSysLog', 'getQosDebug', 'getLldpDebug', 'setQosDebug', 'setLldpDebug']),
    ...mapMutations(['openModal', 'closeModal'])
  },
  computed: {
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo
    })
  }
}
</script>

<style lang="scss" scoped>
.debug {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  .footer-btn {
    width: fit-content;
    padding: 10px;
    line-height: 8px;
    margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .scrollbar-body {
    margin: 10px;
  }
  .footer {
    width: 100%;
    height: 20px;
  }
}
.debug-toggle {
  margin-top: 10px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Debug.vue